import { ValidatorFn, Validators } from '@angular/forms';
import { luhnValidator } from './luhnValidator';

export const orgNumValidator: ValidatorFn[] = [
	Validators.required,
	Validators.minLength(10),
	Validators.maxLength(11),
	luhnValidator,
];
